var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_58_2155)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "#F26A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9106 44.7987L54.9634 38.7058C55.0252 38.3487 55.0082 37.9824 54.9136 37.6325C54.819 37.2826 54.6492 36.9577 54.4159 36.6803C54.1826 36.4029 53.8916 36.1799 53.5631 36.0267C53.2346 35.8736 52.8767 35.7941 52.5143 35.7937H44.7771C44.5966 35.7938 44.4181 35.7545 44.2543 35.6786C44.0904 35.6028 43.945 35.4922 43.8282 35.3545C43.7114 35.2168 43.626 35.0553 43.5779 34.8813C43.5298 34.7072 43.5201 34.5248 43.5496 34.3467L44.5397 28.306C44.7004 27.3252 44.6546 26.3217 44.4053 25.3596C44.2986 24.962 44.0932 24.5979 43.8081 24.3011C43.523 24.0042 43.1674 23.7843 42.7745 23.6616L42.558 23.5914C42.0684 23.4342 41.5372 23.4705 41.0736 23.693C40.5658 23.9379 40.1955 24.3844 40.0581 24.9146L39.3472 27.6534C39.1209 28.525 38.7921 29.3666 38.3676 30.1608C37.7479 31.3211 36.7891 32.2515 35.7915 33.1101L33.6426 34.9619C33.3445 35.2195 33.1116 35.5441 32.9631 35.9091C32.8147 36.2741 32.7548 36.669 32.7884 37.0616L34.001 51.0888C34.0544 51.7091 34.3386 52.2869 34.7972 52.708C35.2559 53.1291 35.8558 53.3629 36.4785 53.3632H43.4197C48.6196 53.3632 53.0563 49.7403 53.9106 44.7987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0724 34.6744C28.361 34.6618 28.6433 34.7612 28.8603 34.9518C29.0774 35.1424 29.2124 35.4095 29.2372 35.6974L30.6857 52.4768C30.7103 52.7267 30.6836 52.979 30.6074 53.2182C30.5312 53.4574 30.407 53.6786 30.2424 53.8682C30.0779 54.0578 29.8764 54.2119 29.6502 54.321C29.4241 54.4302 29.1781 54.4921 28.9273 54.5029C28.6765 54.5138 28.426 54.4734 28.1913 54.3843C27.9566 54.2951 27.7426 54.1591 27.5622 53.9844C27.3818 53.8097 27.239 53.6001 27.1423 53.3684C27.0457 53.1367 26.9973 52.8877 27.0001 52.6366V35.7929C27.0002 35.5042 27.1118 35.2268 27.3116 35.0183C27.5114 34.8099 27.7839 34.6867 28.0724 34.6744Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_58_2155",
    x: 0,
    y: 0,
    width: 78,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_58_2155"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.62e53dd0bbabd878e9bc1adb7b29cecf.svg";
export { ForwardRef as ReactComponent };